// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonSmall = 32;
export var ButtonMedium = 40;
export var ButtonLarge = 48;
export var ControlCheckboxLarge = 18;
export var ControlCheckboxSmall = 16;
export var ControlRadioLarge = 18;
export var ControlRadioSmall = 16;
export var ControlSwitchLarge = 24;
export var ControlSwitchSmall = 20;
export var DatePickerDateCellSmall = 32;
export var DatePickerDateCellMedium = 40;
export var DatePickerDateCellLarge = 48;
export var FieldSmall = 32;
export var FieldMedium = 40;
export var FieldLarge = 48;
export var TagXSmall = 14;
export var TagSmall = 20;
export var TagMedium = 24;
export var TagLarge = 32;